import { useState } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Text,
   Flex,
   Link,
} from '@chakra-ui/react';
import { ExternalTrainingModule } from '~/pages/api/courses/_shared/course-form/course-stage-editor/types';
import { SearchForm } from '~/ui-components';
import { useLocalization } from '~/framework';
import { useDebounced } from '@dozuki/web-js/components';
import { useStageEditor } from '../StageEditor';
import { ModulesCatalog } from './ModulesCatalog';

export function ExternalModuleSearchModal() {
   const { _js } = useLocalization();

   const stageEditor = useStageEditor();

   const [searchTerm, setSearchTerm] = useState('');
   const debouncedSearchTerm = useDebounced(searchTerm, 500);

   function handleClose() {
      stageEditor.closeOpenModal();
      setSearchTerm('');
   }

   function handleModuleSelected(module: ExternalTrainingModule) {
      stageEditor.addStage({
         doctype: 'external_training_module',
         docid: module.external_training_moduleid,
         frequency_unit: null,
         use_datacapture: null,
         frequency_quantity: null,
         strictness: null,
         docSummaryInfo: {
            title: module.title,
            learningStandard: module.learning_standard,
            public: true,
         },
      });
      setSearchTerm('');
   }

   return (
      <Modal isOpen={stageEditor.isETMSearchModalOpen} onClose={handleClose} size="xl">
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>{_js('Choose External Content')}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <SearchForm
                  name="external-modules-search"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  placeholder={_js('Search for External Content')}
               />
               {stageEditor.isETMSearchModalOpen && (
                  <ModulesCatalog
                     searchTerm={debouncedSearchTerm}
                     onSelect={handleModuleSelected}
                  />
               )}
               <Flex minHeight={150} align="center" justify="center">
                  <Flex align="center" direction="column">
                     <Text>{_js("Not finding what you're looking for?")}</Text>
                     <Link href="/external-training-modules" target="_blank" color="blue.600">
                        {_js('Manage External Content')}
                     </Link>
                  </Flex>
               </Flex>
            </ModalBody>
         </ModalContent>
      </Modal>
   );
}
